var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3af32",
    opacity: 0.85,
    d: "M-528,60 C161,-0 161,-0, 881,60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.85,
    d: "M72,60 C648,0 648,0, 1368,60z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e00f",
    opacity: 0.85,
    d: "M672,60 C1248,0 1248,0, 1968,60z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWave);
export default __webpack_public_path__ + "static/media/footer_wave.21232cfa33d877513f1b4910ffdf2c6d.svg";
export { ForwardRef as ReactComponent };